var map = {
	"./frame1.jpg": "2338",
	"./frame2.jpg": "5a79",
	"./frame3.jpg": "916e",
	"./frame4.jpg": "6eda",
	"./frame5.jpg": "8430",
	"./frame6.jpg": "7a1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d00d";